import React, { useState } from 'react';
import styles from './PriceCalculation.module.scss';
import { Plus, Trash2 } from 'lucide-react';

export default function SimpleCalculator({ onError }) {
  const [rows, setRows] = useState([
    { name: '', qtyG: '', pricePerKg: '' },
  ]);

  const addRow = () => {
    setRows((r) => [...r, { name: '', qtyG: '', pricePerKg: '' }]);
  };

  const updateRow = (index, field, value) => {
    setRows((prev) =>
      prev.map((row, i) =>
        i === index ? { ...row, [field]: value } : row
      )
    );
  };

  const removeRow = (index) => {
    setRows((prev) =>
      prev.length > 1 ? prev.filter((_, i) => i !== index) : prev
    );
  };

  const parsed = rows.map((row) => {
    const qtyG = parseFloat(row.qtyG) || 0;
    const qtyKg = qtyG / 1000; // Always calculate from qtyG
    const pricePerKg = parseFloat(row.pricePerKg) || 0;
    const cost = qtyKg * pricePerKg;
    return {
      name: row.name,
      qtyG,
      qtyKg,
      pricePerKg,
      cost,
    };
  });

  const totalCost = parsed.reduce((s, c) => s + c.cost, 0);

  return (
    <div className={styles.calcSection}>
      <h3 style={{ marginBottom: 16, fontSize: 20, fontWeight: 600, color: 'var(--primary-text)' }}>Simple Calculator</h3>
      <div className={styles.tableWrap} style={{ marginBottom: 16 }}>
        <table className={`${styles.table} ${styles.breakdownTable}`}>
          <thead>
            <tr>
              <th>Component</th>
              <th>Qty (g)</th>
              <th>Qty (kg)</th>
              <th>Price per kg</th>
              <th>Component Cost</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => {
              const qtyKg = parsed[i].qtyKg;
              const cost = parsed[i].cost;
              const costDisplay = cost < 0.01 ? cost.toFixed(6) : cost.toFixed(4);
              return (
                <tr key={i}>
                  <td>
                    <input
                      placeholder="Component name"
                      value={row.name}
                      onChange={(e) => updateRow(i, 'name', e.target.value)}
                      style={{ width: 150, padding: '6px 8px', fontSize: 14 }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      placeholder="0"
                      min="0"
                      step="0.01"
                      value={row.qtyG}
                      onChange={(e) => updateRow(i, 'qtyG', e.target.value)}
                      style={{ width: 100, padding: '6px 8px', fontSize: 14, background: 'var(--card-bg)', color: 'var(--primary-text)', border: '1px solid var(--border-color)' }}
                    />
                  </td>
                  <td style={{ padding: '8px', color: 'var(--secondary-text)' }}>
                    {qtyKg.toFixed(6)}
                  </td>
                  <td>
                    <input
                      type="number"
                      placeholder="0"
                      min="0"
                      step="0.01"
                      value={row.pricePerKg}
                      onChange={(e) =>
                        updateRow(i, 'pricePerKg', e.target.value)
                      }
                      onBlur={(e) => {
                        const val = e.target.value;
                        if (val !== '' && (isNaN(parseFloat(val)) || parseFloat(val) < 0)) {
                          updateRow(i, 'pricePerKg', '');
                        }
                      }}
                      style={{ width: 120, padding: '6px 8px', fontSize: 14, background: 'var(--card-bg)', color: 'var(--primary-text)', border: '1px solid var(--border-color)' }}
                    />
                  </td>
                  <td style={{ fontWeight: 500, color: 'var(--primary-text)' }}>{costDisplay}</td>
                  <td>
                    <button
                      type="button"
                      className={styles.btnSecondary}
                      onClick={() => removeRow(i)}
                      title="Remove row"
                      style={{ fontSize: 12, padding: '4px 8px' }}
                    >
                      <Trash2 size={14} />
                    </button>
                  </td>
                </tr>
              );
            })}
            <tr className={styles.totalRow}>
              <td colSpan={4}><strong>Total Component Cost</strong></td>
              <td><strong>{totalCost.toFixed(4)}</strong></td>
              <td />
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ 
        padding: 16, 
        background: 'var(--card-bg)', 
        borderRadius: 8, 
        border: '1px solid var(--border-color)',
        marginTop: 8,
        marginBottom: 16
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <div>
            <div style={{ fontSize: 13, color: 'var(--secondary-text)', marginBottom: 4 }}>Total Component Cost</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--primary-text)' }}>{totalCost.toFixed(4)}</div>
          </div>
          <div style={{ fontSize: 20, color: 'var(--secondary-text)' }}>=</div>
          <div>
            <div style={{ fontSize: 13, color: 'var(--secondary-text)', marginBottom: 4 }}>Product Price per kg</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--accent-color, #2563eb)' }}>
              {totalCost.toFixed(2)}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.btnSecondary} onClick={addRow}>
          <Plus size={16} /> Add row
        </button>
      </div>
    </div>
  );
}
